import L from 'leaflet';
import { mergeClasses } from '@griffel/react';

export default class NumSymbol extends L.Marker
{
	constructor(latlng, value, options = {})
	{
		super(latlng, options);

		this._value = value;
		const img = options.img || '';

		this.setIcon(this.createIcon(value, img, options.className));
	}

	createIcon(text, img, className = '')
	{
		className = mergeClasses('symbol num-symbol', className);

		const iconHtml = `<div class="symbol-inner">
			<div class="text">${text}</div>
			<img src="${img}"/>
		</div>`;

		return L.divIcon({
			className: className,
			html: iconHtml,
			iconSize: [30, 30]
		});
	}
}
